import { atom, useSetAtom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// Define possible sort types
export type SortType = "Ascending" | "Descending" | "Rarity";

// Define the structure of the sort configuration
export interface AggregatorUserConfig {
  maxHops: 1 | 2 | 3 | 4;
  slippageTolerance: number;
}

// Define the initial state for the sort configuration
const initialAggregatorConfig: AggregatorUserConfig = {
  maxHops: 3,
  slippageTolerance: 2,
};

// Create an atom with storage to store the sort configuration in local storage
export const swapAggConfigAtom = atomWithStorage<AggregatorUserConfig>(
  "swapAggConfig",
  initialAggregatorConfig
);
